var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial-state-buybox-feature has-text-center"},[_vm._v("\n  請選擇"),_c('strong',[_vm._v(_vm._s(_vm.unselectedOptions[0].name)+"。")])])}
var staticRenderFns = []

export { render, staticRenderFns }